import { render } from "./HistorialDetallado.vue?vue&type=template&id=22b6c9aa"
import script from "./HistorialDetallado.vue?vue&type=script&lang=js"
export * from "./HistorialDetallado.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__